<template>
  <a href="https://book.timma.dk/skinstudio" target="_blank" rel="noopener"
    ><slot>Book en tid</slot></a
  >
</template>

<script>
export default {
  name: "LinkBooking",
};
</script>
